import { z } from "zod";

// Credentials-step form. Kept deliberately permissive on the password (min 1): the
// backend is the authority on password policy — the client only guards against an
// empty submit. This is the first RHF + Zod usage in the app (Story 2.10); Story
// 2.11 follows the same pattern.
export const credentialsSchema = z.object({
  email: z.string().min(1, "Enter your email.").email("Enter a valid email address."),
  password: z.string().min(1, "Enter your password."),
});

export type CredentialsValues = z.infer<typeof credentialsSchema>;

// Client-side OTP gate (AC2): exactly 6 ASCII digits.
export const OTP_PATTERN = /^[0-9]{6}$/;

/** True when the entered code is a client-side-valid 6-digit OTP. */
export function isOtpComplete(code: string): boolean {
  return OTP_PATTERN.test(code);
}
